import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Apollo } from 'apollo-angular';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  constructor(private router: Router, private apollo: Apollo) {}

  setAccessToken(token) {
    localStorage.setItem('access_token', token);
  }

  getAccessToken() {
    return localStorage.getItem('access_token');
  }

  logout() {
    localStorage.removeItem('access_token');
    this.apollo
      .getClient()
      .resetStore()
      .then(() => {
        window.location.href = '/auth/login';
        // this.router.navigateByUrl('/auth/login').then();
      });
  }
}
